var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"accordion",class:[_vm.classes, {'is-active': _vm.isActive}]},[_c('button',{on:{"click":function($event){return _vm.toggle()}}},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"panel"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }